import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

// src/API/Address/ViewAllAddedAddressByUserAsync.ts
export interface Address {
  id: string;
  email: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  postOfficeName: string;
  pinCode: string;
  blockCode: string;
  addressCode: string;
  latitude: number;
  longitude: number;
  userId: string;
  roleId: string;
  createdDate: string;
  updatedDate: string;
  deleteReason?: string;
  deleteStatus?: boolean;
  pamCode: string;
  addressType: string;
  isDeleteRequestSubmitted: boolean;
  isFavourite: boolean;
  pinnedOrder?: number;
  isClipped: boolean;
  isPrivate: boolean;
  digiPin: string;
  label?: string;
  notes?: string;
  url?: string;
}

/**
 * Fetches all addresses added by the user.
 * @param token - The authentication token.
 * @returns A promise that resolves to an array of addresses.
 */
export async function viewAllAddedAddressByUserAsync(token: string, t: (key: string) => string): Promise<any[] | null> {

  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return null;
  }
  try {
    const baseUrl = getApiBaseUrl();
    const response = await fetch(
      `${baseUrl}/api/address/ViewAllAddedAddressByUserAsync`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    // console.error('Error fetching addresses:', error);
    throw error;
  }
}
function t(arg0: string): import("react-toastify").ToastContent<unknown> {
  throw new Error("Function not implemented.");
}

